<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import type { Building } from "@types"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            heading1: "Informations générales",
            name: "Nom du profil",
            building: "Bâtiments associés",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = withDefaults(
    defineProps<{
        /** Afficher la section bâtiments */
        displayBuilding?: boolean
        /** Nom du profil */
        name?: string
        /** Identifiant de l'entreprise (pour le bloc bâtiments) */
        companyId?: string | null
        /** Bâtiments associés au profil (pour le bloc bâtiments) */
        buildingsProfil?: (Building | { _id: string })[]
    }>(),
    {
        displayBuilding: true,
        name: "Profil sans titre",
        companyId: null,
        buildingsProfil: () => [],
    }
)

const emit = defineEmits<{
    input: [payload: { name: string }]
    "update:buildings": [(Building | { _id: string })[]]
}>()

// ================================
// ÉTAT
// ================================
const nameValue = ref(props.name)

// ================================
// INTERACTIONS
// ================================
function onInputName(value: string): void {
    nameValue.value = value
    emit("input", { name: nameValue.value })
}

function onUpdateBuildings(payload: (Building | { _id: string })[]): void {
    emit("update:buildings", payload)
}

// ================================
// WATCHERS
// ================================
watch(
    () => props.name,
    (val) => {
        nameValue.value = val
    }
)
</script>

<template>
    <div class="usage-profile-edit-general flex flex-col gap-4">
        <h3 class="text-lg font-semibold">
            {{ t("heading1") }}
        </h3>
        <BaseInputWrapper input-id="usage-profile-name" :label="t('name')">
            <BaseInputText
                :model-value="nameValue"
                class="w-full"
                @update:model-value="onInputName($event ?? '')"
            />
        </BaseInputWrapper>
        <UsageProfileEditBuilding
            v-if="displayBuilding"
            :company-id="companyId"
            :buildings-profil="buildingsProfil"
            @update:buildings="onUpdateBuildings"
        />
    </div>
</template>
